import * as React from 'react';
import { useState, useEffect, useMemo } from 'react';
import { useNavigate } from 'react-router';
import { Grid } from '@mui/material';
import { Card } from '../../components/card/Card';
import { Loader } from '../../components/loader/Loader';
import { useAppDispatch } from '../../hooks/useAppDispatch';
import { useAppSelector } from '../../hooks/useAppSelector';
import { IOpportunities } from '../../models/service/service';
import { getOpportunities } from '../../store/actions/actions';
import { routesNames } from '../../utils/constants';
import { filterOpportunities } from '../../utils/filters';
import { useStyles } from './cardsPage.styles';
import { ModalSuccess } from '../../components/modals/modalSuccess/ModalSuccess';

export const CardsPage = (): JSX.Element => {
  const [cardsList, setCardsList] = useState<IOpportunities[]>([]);
  const classes = useStyles();
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const opportunities = useAppSelector((state) => state.organizerReducer.opportunities);
  const loading = useAppSelector((state) => state.organizerReducer?.loading);
  const tabs = useAppSelector((state) => state.organizerReducer.tabs);
  const successVisible = useAppSelector((state) => state.organizerReducer.successVisible);

  useMemo(() => {
    if (opportunities) {
      const filteredOpp = filterOpportunities(tabs, opportunities);
      setCardsList(filteredOpp);
    }
  }, [tabs, opportunities]);

  useEffect(() => {
    getOpportunities()(dispatch);
  }, []);

  if (loading) {
    return <Loader />;
  }

  return (
    <Grid container className={classes.mainGrid}>
      {cardsList.length
        ? cardsList.map((item: IOpportunities) => (
          <Grid item key={item.id} onClick={(): void => navigate(`${routesNames.details}?id=${item.id}`)}>
            <Card item={item} />
          </Grid>
        ))
        : <div>No opportunities</div>
      }
      <ModalSuccess
        open={successVisible}
        title={'Opportunity created'}
        text={'Opportunity has been successfully created'}
      />
    </Grid>
  );
};
